var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVivogaming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 799.6 100",
    style: {
      enableBackground: "new 0 0 799.6 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.9,0c27-0.3,50.1,21.8,50.1,49.9c0,27.7-22.3,50.1-50,50.1c-27.7,0-50-22.3-50-50.1 C199.9,21.9,222.9-0.2,249.9,0z M248.4,89.1c0-0.6,0.1-0.9,0.1-1.2c0-12.4,0-24.8,0-37.2c0-1.3-0.5-1.8-1.5-2.3 c-10.6-6.1-21.2-12.2-31.8-18.3c-0.4-0.2-0.8-0.8-1.4-0.3c0,0.5,0,1.1,0,1.7c0,11.9,0,23.8,0,35.6c0,1.5,0.5,2.3,1.8,3.1 c9,5.1,17.9,10.3,26.9,15.5C244.3,86.7,246.2,87.8,248.4,89.1z M215.5,26.4c0.6,0.4,0.8,0.6,1,0.7c10.7,6.2,21.3,12.3,32,18.5 c1.1,0.7,1.9,0.5,3-0.1c8.1-4.7,16.3-9.4,24.5-14c2.8-1.6,5.5-3.2,8.3-4.8c-0.3-0.5-0.7-0.6-1.1-0.8c-10.7-4.5-21.4-9-32-13.5 c-1-0.4-1.8-0.3-2.7,0.1c-7.1,3-14.2,6-21.3,9C223.4,23.1,219.6,24.6,215.5,26.4z M286.1,29.5c-0.7,0.3-1.1,0.5-1.4,0.7 c-10.6,6-21.1,12.1-31.7,18.1c-1.2,0.7-1.4,1.5-1.4,2.6c0,12,0,24.1,0,36.1c0,0.5-0.2,1.1,0.2,1.6c0.3-0.1,0.5-0.1,0.7-0.2 c10.8-6.2,21.6-12.5,32.4-18.7c1-0.6,1.2-1.3,1.2-2.3c0-6.7,0-13.4,0-20.1C286.1,41.5,286.1,35.7,286.1,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M369.3,86.9c-6.9,0-13.9,0.2-20.8,0c-19-0.8-35.4-15.2-39.1-33.9c-4.4-22.6,9.8-44.3,31.7-49.5 c3.3-0.8,6.7-1.2,10.2-1.2c13.3,0,26.7,0,40,0c0.2,0,0.4,0,0.7,0c1-0.1,1.4,0.3,1.4,1.3c-0.1,3.1,0,6.3,0,9.4c0,1-0.1,2,0,3.1 c0.1,1.1-0.4,1.4-1.4,1.3c-0.4,0-0.9,0-1.3,0c-13.1,0-26.1,0-39.2,0c-9.3,0-16.9,3.7-22.4,11.2c-12.2,16.4-2.1,40.3,18.2,43 c1.4,0.2,2.7,0.3,4.1,0.3c8.2,0,16.5,0,24.7,0c2.1,0,2.1,0.2,2.1-2c0-4.2,0-8.5,0-12.7c0-1.5,0-1.5-1.6-1.5c-7.7,0-15.5,0-23.2,0 c-0.5,0-1,0-1.5,0c-0.7,0-0.9-0.3-0.9-0.9c0-4.4,0-8.8,0-13.1c0-0.9,0.4-1.2,1.2-1.1c0.4,0,0.7,0,1.1,0c12.5,0,25.1,0,37.6,0 c0.4,0,0.7,0,1.1,0c1.1-0.1,1.4,0.4,1.3,1.4c0,0.4,0,0.7,0,1.1c0,13.8,0,27.6,0,41.4c0,0.2,0,0.4,0,0.7c0,1.9,0,1.9-1.9,1.9 C384,87,376.6,87,369.3,86.9C369.3,86.9,369.3,86.9,369.3,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M775.6,86.9c-7,0-14,0.2-21,0c-18.8-0.8-35.3-15.3-38.9-33.9c-4.4-22.5,9.7-44.3,31.9-49.6 c3.3-0.8,6.6-1.1,10-1.1c13.4,0,26.7,0,40.1,0c0.2,0,0.4,0,0.7,0c1.1-0.1,1.4,0.3,1.4,1.4c-0.1,3.4,0,6.9,0,10.3 c0,0.7-0.1,1.5,0,2.2c0.1,1.1-0.4,1.4-1.4,1.3c-0.4,0-0.9,0-1.3,0c-13.1,0-26.1,0-39.2,0c-10,0-17.9,4.2-23.4,12.6 C723.6,46.6,734,69,753.5,71.6c1.3,0.2,2.6,0.3,3.9,0.3c8.4,0,16.8,0,25.2,0c1.8,0,1.8,0,1.8-1.7c0-4.3,0-8.6,0-12.9 c0-1.5,0-1.5-1.6-1.5c-7.6,0-15.2,0-22.8,0c-0.5,0-1-0.1-1.5,0c-1.1,0.1-1.4-0.3-1.4-1.3c0.1-3.3,0-6.6,0-9.8c0-1.2-0.5-2.8,0.2-3.6 c0.8-0.9,2.5-0.3,3.8-0.3c11.9,0,23.8,0,35.7,0c0.5,0,1,0,1.5,0c0.9-0.1,1.2,0.3,1.1,1.2c0,0.4,0,0.9,0,1.3c0,13.9,0,27.7,0,41.6 c0,2.6,0.2,2.4-2.3,2.4C790,87,782.8,87,775.6,86.9C775.6,86.9,775.6,86.9,775.6,86.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M702.9,87.1c-23.3-18-46.2-35.6-69.2-53.4c-0.6,0.8-0.3,1.6-0.3,2.3c0,16,0,32,0,47.9 c0,0.4,0,0.9,0,1.3c0,1.6,0,1.6-1.5,1.6c-4.1,0-8.2,0-12.3,0c-1.1,0-1.6-0.3-1.5-1.5c0.1-0.7,0-1.5,0-2.2c0-26,0-51.9,0-77.9 c0-0.8,0-1.6,0-2.8c23.2,17.9,46.2,35.6,69.3,53.4c0.5-0.9,0.3-1.7,0.3-2.5c0-16.3,0-32.5,0-48.8c0-2.7-0.3-2.3,2.3-2.4 c3.8,0,7.6,0,11.4,0c1.5,0,1.6,0,1.6,1.6c0,6.6,0,13.1,0,19.7c0,20.3,0,40.6,0,60.8C702.9,85.1,702.9,85.8,702.9,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M578.6,2.5c0.4,0.9,0.3,1.7,0.3,2.4c0,26.6,0,53.1,0,79.7c0,2.6,0.3,2.4-2.3,2.4c-3.6,0-7.2,0-10.7,0 c-2.5,0-2.1,0.3-2.1-2.3c0-16.3,0-32.5,0-48.8c0-0.7,0-1.4,0-2.2c-0.9-0.3-1.2,0.4-1.7,0.8c-8,6.1-15.9,12.3-23.9,18.4 c-1.8,1.4-1.2,1.4-3.1,0c-7.8-6-15.6-12-23.4-18c-0.6-0.5-1.2-0.9-2.2-1.7c0,1.1,0,1.9,0,2.7c0,16.1,0,32.3,0,48.4 c0,0.4,0,0.9,0,1.3c0.1,1.1-0.3,1.4-1.4,1.4c-3.2,0-6.4,0-9.6,0c-1.1,0-2.2,0-3.3,0c-0.8,0-1.1-0.3-1-1c0-0.4,0-0.7,0-1.1 c0-26.7,0-53.4,0-80.1c0-0.6-0.1-1.3,0.2-2.1c0.9,0.3,1.5,0.9,2.1,1.4c12.8,9.8,25.5,19.7,38.3,29.5c0.3,0.3,0.7,0.5,1,0.8 c0.5,0.4,0.9,0.4,1.3,0c0.5-0.4,1-0.8,1.6-1.2c12.7-9.8,25.4-19.6,38.1-29.4C577.4,3.4,577.9,3,578.6,2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M159.1,60.6c0.7-0.5,0.9-1.1,1.2-1.7c8-15.8,16.1-31.5,24.1-47.3c0.7-1.4,1.5-2,3.1-2 c4.2,0.1,8.5,0,12.7,0.1c0.6,0,1.3-0.2,2.1,0.3c-14.3,28-28.5,56-43,84.4c-14.5-28.4-28.7-56.4-43-84.3c0.5-0.6,1.1-0.4,1.5-0.4 c4.5,0,9,0,13.6,0c1.3,0,1.9,0.4,2.5,1.5c7.7,15.1,15.4,30.3,23.1,45.4C157.7,57.8,158.4,59.2,159.1,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M443.6,36c-1.1,2.1-2.1,4.1-3.2,6.2c-7.3,14.3-14.6,28.5-21.8,42.8c-0.7,1.4-1.5,2-3.1,2 c-4.8-0.1-9.6,0-14.3,0c-0.1-0.2-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2-0.1-0.2c0.5-1.3,41.7-82.2,42.9-84.1C458.2,30.6,472.5,58.6,487,87 c-2.7,0-5.1,0-7.5,0c-2.6,0-5.1-0.1-7.7,0c-1.3,0-2.1-0.3-2.7-1.6c-5.4-10.8-11-21.6-16.4-32.3c-2.7-5.3-5.3-10.5-8-15.8 C444.4,36.9,444.3,36.3,443.6,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M0,9.6c5.6,0,10.8,0,16,0c1,0,1.4,0.6,1.7,1.3c2.7,5.3,5.4,10.6,8.1,16c5.5,10.8,11,21.5,16.5,32.3 c0.2,0.4,0.5,0.9,0.7,1.4c0.9-0.5,1.1-1.4,1.4-2.2c8-15.6,16-31.3,23.9-46.9c0.7-1.3,1.4-1.9,3-1.8c4.9,0.1,9.8,0,15,0 C71.9,37.9,57.7,66,43.2,94.4C28.7,66,14.5,38,0,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M606.2,44.6c0,13.3,0,26.6,0,39.8c0,0.5,0,1,0,1.5c0.1,0.8-0.3,1-1,1c-1,0-2,0-3.1,0 c-3.3,0-6.6,0-9.8,0c-0.9,0-1.4-0.2-1.3-1.2c0-0.4,0-0.7,0-1.1c0-26.6,0-53.3,0-79.9c0-2.8-0.3-2.4,2.4-2.5c3.6,0,7.3,0,10.9,0 c1.8,0,1.8,0,1.8,1.8c0,4.1,0,8.2,0,12.3C606.2,25.8,606.2,35.2,606.2,44.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M108.8,9.6c0,1,0,1.7,0,2.4c0,26.6,0,53.1,0,79.7c0,0.3,0,0.6,0,0.9c0,1.6,0,1.7-1.7,1.7 c-4,0-8,0-12,0c-1.1,0-1.6-0.3-1.5-1.5c0-0.4,0-0.7,0-1.1c0-26.6,0-53.1,0-79.7c0-2.7-0.5-2.4,2.4-2.4 C100.2,9.6,104.4,9.6,108.8,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M217.9,62c0-1.6,0.1-2.6,1.1-3.2c1.1-0.6,2.1-0.1,3,0.5c2.3,1.7,3.4,4.1,3.7,6.9 c0.1,1-0.1,2.1-1.1,2.7c-1,0.6-2,0.2-2.8-0.4C219.4,66.8,218.2,64.4,217.9,62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.2,60.9c0,1.4-0.1,2.5-1.1,3c-1,0.5-2,0.2-2.9-0.4c-2.3-1.8-3.6-4.2-3.8-7.1 c-0.1-1,0.2-2.1,1.2-2.7c1-0.6,2-0.2,2.8,0.5C232.7,56,233.9,58.4,234.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M242.6,56.3c0,1.1-0.1,2.1-1.1,2.7c-1.1,0.6-2.1,0.1-3-0.6c-2.2-1.8-3.4-4.1-3.6-6.9 c-0.1-1,0.1-2.1,1.1-2.7c1-0.5,2-0.2,2.9,0.4C241.1,51,242.4,53.4,242.6,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M250,30c-2,0-3.9-0.3-5.7-1.3c-2.3-1.4-2.4-3.4,0-4.7c3.6-1.9,7.5-1.9,11.1,0c2.4,1.2,2.3,3.3,0,4.7 C253.8,29.6,252,30,250,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.3,60.2c0.3-2.2,1.2-4.3,3.1-5.8c0.9-0.7,1.9-1.1,3-0.6c1.2,0.5,1.5,1.7,1.5,2.8 c0,2.4-0.9,4.6-2.7,6.2c-0.9,0.9-2,1.5-3.4,1C265.8,63.3,265.2,62,265.3,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.1,42.6c-0.2,2.1-1.2,4.3-3.4,5.8c-2.1,1.4-4,0.5-4.2-2c-0.2-2.7,0.8-4.9,2.7-6.6 c0.9-0.9,2-1.5,3.4-0.9C280.6,39.3,281.1,40.5,281.1,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264.6,50.5c-0.1,2.6-1.1,4.8-3.2,6.4c-0.9,0.7-2,1-3.1,0.5c-1-0.5-1.3-1.5-1.3-2.6 c0-2.6,1-4.8,2.9-6.5c0.9-0.8,2-1.3,3.2-0.7C264.4,48,264.5,49.2,264.6,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264.4,72.2c-0.1,2.4-1.1,4.5-3,6c-0.9,0.7-1.9,1.1-3,0.6c-1.2-0.5-1.4-1.6-1.5-2.7 c-0.1-2.5,0.9-4.5,2.6-6.2c1-1,2.2-1.6,3.6-1C264.4,69.6,264.5,70.9,264.4,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281,63.6c-0.2,2.3-1.1,4.4-3,5.9c-0.9,0.8-1.9,1.4-3.2,0.7c-1.2-0.6-1.5-1.8-1.4-3 c0-2.4,1-4.6,2.8-6.2c0.9-0.8,1.9-1.4,3.2-0.8C280.7,61,281,62.2,281,63.6z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivogaming);
export default __webpack_public_path__ + "static/media/vivogaming.d9fee972bbc7e0cf19865482ca22266c.svg";
export { ForwardRef as ReactComponent };